const truncateToken = (token) => {
  if (token.length > 4) {
    return token.slice(-4);
  }
  return token;
};

export default truncateToken;
